import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Form, Field } from 'formik'
import { Alert, Input, Spinner } from '@wellbeingxltd/fe-lib/components'
import { Toolbar } from 'components'
import { forgotPassword, forgotPasswordSubmit } from 'awsApi'
import { emailSchema, newPasswordSchema } from './schema'
import '../styles.scss'

function ForgotPassword(props) {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [emailSucceded, setEmailSuceeded] = useState(false)
    const [email, setEmail] = useState(false)

    const onSubmit = values => {
        setLoading(true)
        if (emailSucceded) {
            setLoading(false)
            const { email, password, confirmationCode: code } = values
            forgotPasswordSubmit(
                email,
                code,
                password,
                () => {
                    Alert('Successfully reseted password', 'success')
                    history.goBack()
                },
                err => {
                    Alert('Failed to reset password', 'error')
                }
            )
        } else {
            const { email } = values
            forgotPassword(email, () => {
                Alert('Please check your email for the confirmation code', 'success')
                setEmailSuceeded(true)
                setEmail(email)
                setLoading(false)
            })
        }
    }

    return (
        <div className="landing-container">
            <Toolbar buttonTitle="Login" onButtonClicked={() => history.goBack()} />
            <div className="landing-card">
                <h1>Reset password</h1>
                <Formik
                    enableReinitialize={true}
                    initialValues={emailSucceded ? { email: email, password: '', confirmationCode: '' } : { email: '' }}
                    validationSchema={emailSucceded ? newPasswordSchema : emailSchema}
                    onSubmit={onSubmit}
                >
                    <Form>
                        <Field name="email">
                            {({ field, form, meta }) => (
                                <Input
                                    type="email"
                                    touched={meta.touched}
                                    error={meta.error}
                                    {...field}
                                    labelAbove="WORK EMAIL"
                                    onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())}
                                />
                            )}
                        </Field>
                        {emailSucceded && (
                            <>
                                <Field name="password">
                                    {({ field, meta }) => (
                                        <Input labelAbove="NEW PASSWORD" type="password" {...field} error={meta.error} touched={meta.touched} />
                                    )}
                                </Field>
                                <Field name="confirmationCode">
                                    {({ field, meta }) => (
                                        <Input labelAbove="CONFIRMATION CODE" {...field} error={meta.error} touched={meta.touched} />
                                    )}
                                </Field>
                            </>
                        )}
                        <button disabled={loading} type="submit" className="landing-card-button">
                            {loading ? <Spinner /> : 'CONTINUE'}
                        </button>
                    </Form>
                </Formik>
            </div>
        </div>
    )
}

export default ForgotPassword
